import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import moment from "moment";
import cogoToast from "cogo-toast";
import SsrsService from "../services/ssrs-service";
const GenerateSsrs = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [totalMonths, setTotalMonths] = useState([]);
  const [repMnth, setRepMnth] = useState();
  const [repYear, setRepYear] = useState(moment().format("YYYY"));
  const [repType, setRepType] = useState("pdf");
  const {  handleSubmit } = useForm({});

  const totalYears = () => {
    const years = [];
    const dateStart = moment().subtract(2, "y");
    const dateEnd = moment().add(6, "y");
    while (dateEnd.diff(dateStart, "years") >= 0) {
      years.push(dateStart.format("YYYY"));
      dateStart.add(1, "year");
    }
    return years;
  };
  const totalYearsList = () => {
    return totalYears().map((i) => (
      <option value={i} key={i}>
        {i}
      </option>
    ));
  };
  const onSubmit = async () => {
    try {
      setLoading(true);
      if (repMnth) {
        let params = {
          type: repType,
        };
        let resp = await SsrsService.generateSsrsFile(params);
        if (repType === "pdf") {
          let pdfWindow = window.open("");
          pdfWindow.document.write(
            "<html<head><title>SSRS</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>"
          );
          pdfWindow.document.write(
            "<body><embed width='100%' height='100%' src='data:application/pdf;base64, " +
              encodeURI(resp) +
              "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>"
          );
        } else {
          const anchor_href =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
            resp;
          const exportLinkElement = document.createElement("a");
          exportLinkElement.hidden = true;
          exportLinkElement.download = "report.xlsx";
          exportLinkElement.href = anchor_href;
          exportLinkElement.text = "downloading...";

          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          setLoading(false);
        }
      } else {
        const { hide } = cogoToast.error("Please Select Month", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
      setLoading(false);
      //let resp = await auth.createUser(new_user);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error saving user details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  useEffect(() => {
    setTotalMonths(moment.months());
  }, []);
  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">GENERATE SSRS</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <form onSubmit={handleSubmit(onSubmit)}>
            <ul>
              <li className="inline-block text-xs leading-6 text-menu_txt w-1/3 mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Select Month
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <select
                  name="ssrsMnth"
                  aria-label="Select Month"
                  id="ssrsMnth"
                  onChange={(e) => {
                    setRepMnth(e.target.value);
                  }}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal text-fogotpwsd_login text-sm w-11/12"
                >
                  <option value="">Select Month</option>
                  {totalMonths
                    ? totalMonths.map((monthName, i) => {
                        return (
                          <option key={i} value={("0" + (i + 1)).slice(-2)}>
                            {monthName}
                          </option>
                        );
                      })
                    : null}
                </select>
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-1/3 mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Select Year
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <select
                  name="ssrsYear"
                  aria-label="Select Year"
                  id="ssrsYear"
                  defaultValue={repYear}
                  onChange={(e) => {
                    setRepYear(e.target.value);
                  }}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal text-fogotpwsd_login text-sm w-11/12"
                >
                  {totalYearsList()}
                </select>
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-1/3 mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Report Type
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <select
                  name="repType"
                  aria-label="Report Type"
                  id="repType"
                  onChange={(e) => {
                    setRepType(e.target.value);
                  }}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal text-fogotpwsd_login text-sm w-full"
                >
                  <option value="pdf">PDF</option>
                  <option value="excel">XLSX</option>
                </select>
              </li>
              <li className="inline-block text-sm leading-8 w-full">
                <button
                  type="submit"
                  className="rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
                  aria-label="Create user"
                >
                  SUBMIT
                </button>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(GenerateSsrs)
);
